export default __webpack_public_path__ + "static/media/virtual-bg6.7f3e4c79.png";